import React,{useState,useEffect} from 'react';

import {
  convertToISOFormat,
  getTimeDifference,
  shortEnglishHumanizer,
} from "../../utils";

import {
  Calendar,
  Camera,
  CameraIcon,
  Clock,
  CloudDownload,
  ScanFace,
  CheckCircle,
  Square,
  Circle,
  RotateCcw,
  AlertTriangle,
  X,
  Users,
  NotebookPen,
  TriangleAlert,
} from "lucide-react";
import { examImagesForSlide, ServerStatus } from "../../environment";
import { ExamsDetailsTypes } from "../../interfaces/exams.interface";
import { title } from "process";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import humanizeDuration from "humanize-duration";
import toast from "react-hot-toast";
import ShowResultDialog from "./ShowResultDialog";
import FaceRecognitionDialog from "../../components/./FaceVerification/FaceRecognitionModal";
import useExamStores from "../../stores/useExamStores";
import { useUserContext } from '../../context/UserContext';
import useUserStore from "../../stores/useUserStores";

export interface ExaminationSlideProps {
  details: ExamsDetailsTypes;
  indexNum: number;
  startTest: any;
  resumeTest: any;
  setSelectedExamForScrutiny?: React.Dispatch<
    React.SetStateAction<ExamsDetailsTypes | null | undefined>
  >;
  refreshList?: () => void;
  noShowResult?: boolean;
  currentDateTime: string;
  currentTime:
    | {
        date: string;
        time: string;
      }
    | undefined;
}

export const ExaminationSlide: React.FC<ExaminationSlideProps> = ({
  details,
  indexNum,
  startTest,
  refreshList,
  resumeTest,
  noShowResult,
  setSelectedExamForScrutiny,
  currentDateTime,
  currentTime,
}) => {
  const formattedCurrentDatetime = convertToISOFormat(currentDateTime);

  const examContext = useExamStores();
  const userDataStore = useUserStore();
  const examContextDetails: any = useUserContext();
  const [image, setImage] = useState<any>(null);
  const [openFaceRecogition, setOpenFaceRecognition] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [resultDialogDertails, setResultDialogDetails] = useState<
    ExamsDetailsTypes | null | undefined
  >();
  const [isResumeCase, setIsResume] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const [examIn, SetTime] = useState<number>(1000);
  const navigate = useNavigate();

  const startExamHandeler = () => {
    // setOpenFaceRecognition(false);

    if (examIn <= 0 && !isResumeCase) {
      startTest(details);
      userDataStore.setExamStarted(true);
    } else if (examIn <= 0 && isResumeCase) {
      resumeTest(details);
      userDataStore.setExamStarted(true);
    } else {
      toast.error("Something went wrong!");
    }
  };

  const handleClose = () => {
    setOpen(false);
    if (examIn <= 0 && !isResumeCase) {
      if (
        details?.face_verification &&
        !examContext.faceVerfied &&
        ServerStatus === "ONLINE"
      ) {
        setOpenFaceRecognition(true);
        examContextDetails.enterFullscreen?.();
      } else if (
        details?.face_verification &&
        examContext.faceVerfied &&
        ServerStatus === "ONLINE"
      ) {
        startTest(details);
        userDataStore.setExamStarted(true);
        examContextDetails.enterFullscreen?.();
      } else startTest(details);
    } else if (examIn <= 0 && isResumeCase) {
      if (details?.face_verification && ServerStatus === "ONLINE") {
        setOpenFaceRecognition(true);
        userDataStore.setExamStarted(true);

        examContextDetails.enterFullscreen?.();
      } else {
        resumeTest(details);
        userDataStore.setExamStarted(true);
      }
    }
  };

  useEffect(() => {
    if (currentTime && currentTime.date && currentTime.time) {
      setTimeout(() => {
        SetTime(
          new Date(details.exam_start_time as any).getTime() -
            new Date(
              convertToISOFormat(`${currentTime?.date} ${currentTime?.time}`)
            ).getTime()
        );
      }, 1000);
    }
  }, [examIn, currentTime]);

  useEffect(() => {
    if (details && details?.resume_exam) {
      setIsResume(details.resume_exam);
    } else {
      setIsResume(false);
    }
  }, [details]);

  useEffect(() => {
    const randomIndex = Math.floor(Math.random() * examImagesForSlide.length);
    setImage(examImagesForSlide[randomIndex]);
  }, []);

  return (
    <div className="relative bg-white col-span-4 mx-1 lg:mx-0  rounded-lg shadow-lg pb-3 overflow-hidden hover:shadow-md transition-shadow duration-300">
      <FaceRecognitionDialog
        open={openFaceRecogition}
        setOpen={setOpenFaceRecognition}
        successCallback={startExamHandeler}
        examDetails={details}
      />

      {resultDialogDertails ? (
        <ShowResultDialog
          resultDetails={resultDialogDertails}
          handleClose={() => setResultDialogDetails(null)}
        />
      ) : (
        <></>
      )}
      {open ? (
        <GuideLine
          examIn={examIn}
          handleClose={handleClose}
          open={open}
          isResume={isResumeCase}
          setOpen={setOpen}
        />
      ) : (
        <></>
      )}

      <div className=" h-48 overflow-hidden relative">
        <img
          src={
            details?.file_data
              ? `data:image/png;base64,${details?.file_data}`
              : image
          }
          alt={"logo"}
          // src={
          //   indexNum % 2 === 0
          //     ? examinationImages[2]
          //     : indexNum % 3 === 0
          //     ? examinationImages[3]
          //     : examinationImages[1]
          // }

          className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
        />
        {details &&
        (details?.is_proctor_enabled || details?.face_verification) &&
        examContext.CameraFound ? (
          <div
            className={`absolute bottom-0 right-0 px-2  text-[10px] font-semibold text-fuchsia-700 bg-fuchsia-200 flex items-center gap-x-2 rounded-tl-md py-1`}
          >
            <Camera size={10} />
            <span>Device Camera Found & Activated</span>
          </div>
        ) : (
          <></>
        )}

        {/* <Calendar className='size-4' /> */}
        {/* <div>
            <p className="text-[10px] leading-none pt-1">Exams Date</p>
            <p className="text-[13px] leading-none py-1">{category}</p>
          </div>
        </div>
        <div
          className={`absolute top-0 left-[38%] px-3  text-xs font-semibold text-emerald-700 bg-emerald-200 flex items-center gap-x-2`}
        >
          
          <div>
            <p className="text-[10px] leading-none pt-1">Exams Date</p>
            <p className="text-[13px] leading-none py-1">{category}</p>
          </div>*/}
        {/* </div>  */}
        {details &&
        details?.is_proctor_enabled &&
        details?.face_verification ? (
          <div
            className={`absolute top-0 left-0 px-2  text-[10px] font-semibold text-indigo-700 bg-indigo-200 flex items-center gap-x-2 rounded-br-md py-1`}
          >
            <ScanFace size={10} />
            <span>Facial Scan & Proctoring</span>
          </div>
        ) : details && details?.is_proctor_enabled ? (
          <div
            className={`absolute top-0 left-0 px-2  text-[10px] font-semibold text-indigo-700 bg-indigo-200 flex items-center gap-x-2 rounded-br-md py-1`}
          >
            <ScanFace size={10} />
            <span>Proctoring Enabled</span>
          </div>
        ) : details && details?.face_verification ? (
          <div
            className={`absolute top-0 left-0 px-2  text-[10px] font-semibold text-indigo-700 bg-indigo-200 flex items-center gap-x-2 rounded-br-md py-1`}
          >
            <ScanFace size={10} />
            <span>Facian Scan Enabled</span>
          </div>
        ) : (
          <></>
        )}

        {details?.exam_start_time &&
        new Date(details.exam_start_time as any).getTime() <
          new Date(formattedCurrentDatetime).getTime() &&
        new Date(details.exam_end_time as any).getTime() >
          new Date(formattedCurrentDatetime).getTime() &&
        details.status !== "PUBLISHED" ? (
          <div
            className={`absolute top-0 right-0 px-2  text-[12px] font-semibold text-emerald-700 bg-emerald-200 flex items-center gap-x-2 rounded-bl-md py-1`}
          >
            Exam is going on...
          </div>
        ) : (
          <></>
        )}

        {!!details.exam_end_time &&
        new Date(details.exam_end_time).getTime() <
          new Date(formattedCurrentDatetime).getTime() &&
        details?.status !== "PUBLISHED" ? (
          <>
            <div
              className={`absolute top-0 right-0 px-2  text-[12px] font-semibold text-stone-700 bg-stone-200 flex items-center gap-x-2 rounded-bl-md py-1`}
            >
              Exam is closed
            </div>
          </>
        ) : (
          <></>
        )}

        {details.status === "PUBLISHED" ? (
          <div
            className={`absolute top-0 right-0 px-2  text-[12px] font-semibold text-amber-700 bg-amber-200 flex items-center gap-x-2 rounded-bl-md py-1`}
          >
            Result Published
          </div>
        ) : (
          <></>
        )}
        {examIn &&
        examIn > 0 &&
        details &&
        formattedCurrentDatetime &&
        new Date(details.exam_start_time as any).getTime() >
          new Date(formattedCurrentDatetime).getTime() ? (
          <div
            className={`absolute top-0 right-0 px-2  text-xs font-semibold text-red-700 bg-red-200 flex items-center gap-x-2 rounded-bl-md`}
          >
            {/* <Calendar className='size-4' /> */}

            <div>
              <div className="flex items-center">
                <div className="flex items-center ">
                  <Clock className="size-4 mt-1 pt-1" />
                  <p className="text-[13px] pl-1 leading-none pt-1">
                    Exam start in
                  </p>
                </div>
              </div>
              {details.exam_start_time &&
              currentTime &&
              currentTime?.time &&
              currentTime?.date ? (
                <div className="flex justify-center">
                  {getTimeDifference(
                    new Date(details.exam_start_time),
                    new Date(
                      convertToISOFormat(
                        `${currentTime?.date} ${currentTime?.time}`
                      )
                    )
                  )}
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
      <div className="">
        <div className="flex lg:flex-row flex-col lg:justify-between ">
          <div className="flex lg:flex-col  justify-between lg:mr-0 mr-2 ml-1 md:ml-0">
            <h3 className="text-lg font-semibold text-gray-800 md:ml-1  line-clamp-2 ">
              {details.title}
            </h3>
            <p className="text-sm  text-gray-600 leading-none md:ml-1 ">
              {" "}
              {details.exam_group_title}
            </p>
          </div>
          {!!details.org_name ? (
            <div className="ml-1 md:ml-0">
              <p className="leading-none text-[11px] lg:mt-2 hidden lg:block  pr-2 text-gray-700">
                Organized by
              </p>
              <h6 className="lg:text-md text-sm lg:text-start  mr-1 text-gray-700 font-semibold  lg:mr-3  line-clamp-2   ">
                {details.org_name}
              </h6>
            </div>
          ) : (
            <></>
          )}
        </div>
        <div className="h-[1.5px] bg-gray-200 w-full my-2"></div>
        <div className="flex items-center justify-between mb-2 px-1">
          <div className={`   text-xs font-semibold  flex  gap-x-2 flex-col`}>
            <p className="text-[10px] leading-none pt-1">Exam Date</p>
            <p className="text-[13px] leading-none py-1">
              {details?.exam_start_time
                ? moment(details.exam_start_time).format("DD-MMM-YYYY")
                : "N/A"}
            </p>
          </div>
          <div className={`   text-xs font-semibold  flex  gap-x-2 flex-col`}>
            <p className="text-[10px] leading-none pt-1">Start Time</p>
            <p className="text-[13px] leading-none py-1">
              {details?.exam_start_time
                ? moment(details.exam_start_time).format("hh:mm a")
                : "N/A"}
            </p>
          </div>
          <div className={`   text-xs font-semibold  flex  gap-x-2 flex-col`}>
            <p className="text-[10px] leading-none pt-1">End Time</p>
            <p className="text-[13px] leading-none py-1">
              {details?.exam_end_time
                ? moment(details.exam_end_time).format("hh:mm a")
                : "N/A"}
            </p>
          </div>
        </div>

        <div className="flex items-center justify-between text-sm text-gray-500 py-1">
          <div className="flex items-center flex-col bg-indigo-100 px-4 py-[4px]  ">
            <p className="text-[11px] leading-none text-indigo-700 font-semibold">
              Total Questions
            </p>
            <p className="text-[11px] leading-none mt-1 text-indigo-700 font-semibold">
              {details?.total_questions}
            </p>
          </div>
          <div className="flex items-center flex-col bg-emerald-100 px-4 py-[4px] ">
            <p className="text-[11px] leading-none text-emerald-700 font-semibold">
              Total Marks
            </p>
            <p className="text-[11px] leading-none mt-1 text-emerald-700 font-semibold">
              {details?.total_marks}
            </p>
          </div>
          <div className="flex items-center flex-col bg-pink-100 px-4 py-[4px]  ">
            <p className="text-[11px] leading-none text-pink-700 font-semibold">
              Exam Duration
            </p>
            <p className="text-[11px] leading-none mt-1 text-pink-700 font-semibold">
              {humanizeDuration(details.duration * 60 * 1000)}
            </p>
          </div>
        </div>
        <div className="h-[1px] bg-gray-200 w-full my-1"></div>

        {!!details.exam_end_time &&
        new Date(details.exam_end_time as any).getTime() <
          new Date(formattedCurrentDatetime).getTime() &&
        details.status !== "PUBLISHED" ? (
          <div className="text-sm  font-semibold text-gray-600 mt-3 mx-2 flex justify-between   items-center w-[96%]">
            {details.status !== "PUBLISHED" ? (
              <div className="">
                <p className="md:text-[12px]  text-stone-500 leading-none">
                  Closed at{" "}
                </p>
                <p className="text-stone-500 font-semibold mt-1 leading-none">
                  {moment(details.exam_end_time).format("DD-MMM-YYYY hh:mm a")}{" "}
                </p>
              </div>
            ) : (
              <></>
            )}
          </div>
        ) : (
          <></>
        )}

        {!details.is_exam_cancelled && details.status === "PUBLISHED" ? (
          <div className="flex justify-between px-3 py-2 items-center">
            <div
              className="cursor-pointer group"
              onClick={() => setSelectedExamForScrutiny?.(details)}
            >
              <p className="md:text-[12px] group-hover:underline underline-offset-4 hidden lg:block font-bold animate-pulse text-blue-600 leading-none">
                Raise Objection/View Answer Keys
              </p>
              <p className="text-[14px] group-hover:underline underline-offset-4 block lg:hidden animate-pulse text-blue-600 leading-none">
                Answer Keys
              </p>
            </div>
            {!noShowResult ? (
              <button
                onClick={() => setResultDialogDetails(details)}
                type="button"
                className="gap-x-2 items-center cursor-pointer flex rounded border bg-blue-600 text-white hover:text-gray-600 hover:bg-blue-600 border-blue-500  px-4 py-1 text-sm max-sm:text-[10px] max-sm:p-1 leading-normal"
              >
                <CloudDownload size={17} />
                Download Result
              </button>
            ) : (
              <></>
            )}
          </div>
        ) : details.is_exam_cancelled ? (
          <div className="">
            <div className="text-red-400 bg-red-100 px-2 mx-2 font-bold mt-3">
              Exam Cancelled
            </div>
            <div className="px-2 mx-2">
              <p className="font-semibold mt-2 ">Reason for cancellation :</p>
              <p>{details?.cancellation_reason}</p>
            </div>
          </div>
        ) : (
          <></>
        )}

        {!!examIn &&
        new Date(details.exam_end_time as any).getTime() >
          new Date(formattedCurrentDatetime).getTime() &&
        details.status !== "PUBLISHED" ? (
          <div className="flex  mt-5 mb-2 px-2  items-center justify-end">
            {(details?.face_verification || details?.is_proctor_enabled) &&
            !examContext.CameraFound ? (
              <>
                <div
                  className={`  text-[10px] font-semibold text-gray-700 bg-red-50 flex flex-col px-3 gap-x-2 rounded-md py-1`}
                >
                  <div className="font-semibold text-lg text-red-400 flex gap-x-1 items-center">
                    <CameraIcon size={16} />
                    <p> Camera Access Required</p>
                  </div>
                  <p className="text-xs text-gray-700">
                    This exam uses{" "}
                    {details?.face_verification && details.is_proctor_enabled
                      ? `Face Recognition and AI Proctoring`
                      : details?.face_verification
                      ? `Face Recognition`
                      : details?.is_proctor_enabled
                      ? `AI Proctoring`
                      : ""}{" "}
                    . Please switch to a device with a working camera to
                    proceed.
                  </p>
                </div>
              </>
            ) : (
              <button
                type="button"
                className="inline-block cursor-pointer rounded duration-500 ease-in-out border hover:border-blue-500 font-semibold cta-button hover:text-gray-700 hover:bg-white  text-gray-600 text-white bg-blue-600 border-blue-500  px-4 py-1 text-sm max-sm:text-[10px] max-sm:p-1 leading-normal"
                onClick={() => {
                  if (
                    new Date(details.exam_end_time as any).getTime() <
                    new Date(formattedCurrentDatetime).getTime()
                  )
                    return toast.error("Exam is closed");

                  handleOpen();
                }}

                // className="inline-block cursor-pointer rounded border border-blue-500 text-gray-600 hover:text-white hover:bg-blue-600 border-blue-500  px-4 py-2 text-sm max-sm:text-[10px] max-sm:p-1 leading-normal"
              >
                {examIn > 0
                  ? "Read Instructions"
                  : isResumeCase
                  ? "Resume Exam"
                  : "Start Exam"}
              </button>
            )}
          </div>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

const Renderer = ({ hours, minutes, seconds, completed, handleOpen }: any) => {
  if (completed) {
    // handleOpen();
    return <span className="text-red-500"></span>;
  } else {
    return (
      <span style={{ fontWeight: "bold", color: "red" }}>
        {hours < 10 ? `0${hours}` : hours}:
        {minutes < 10 ? `0${minutes}` : minutes}:
        {seconds < 10 ? `0${seconds}` : seconds}
      </span>
    );
  }
};

// const GuideLine = ({ handleClose, open, examIn, isResume }: any) => {
//   if (!open) return <></>;
//   return (
//     <Modal
//       style={{ backdropFilter: "blur(1px)" }}
//       open={open}
//       onClose={handleClose}
//       aria-labelledby="modal-modal-title"
//       aria-describedby="modal-modal-description"
//     >
//       <Box className="">
//         <div className="fixed top-0 left-0 flex items-center justify-center w-full h-full min-h-screen">
//           <div className="w-full lg:max-w-[60%] max-w-[95%]  bg-slate-50  rounded-sm text-center  ">
//             <div className="h-24 md:h-40 flex  justify-center  items-center flex-col bg-gradient-to-br from-slate-800 via-slate-600 to-slate-700 ">
//               {/* <img src={coinimg} className="w-12 h-12" /> */}
//               <p className="md:text-xl text-xs  text-yellow-400 font-semibold uppercase  ">
//                 Please note that your exam will be closed if you:
//               </p>
//             </div>
//             <div className="p-5 text-start">
//               <ul className="list-disc pl-2">
//                 <li>Move out of exam console.</li>
//                 <li>Press special keys from your keyboard.</li>
//                 <li>Try to minimize or toggle the assessment console.</li>
//                 <li>
//                   If you switch to another application or window during the exam
//                   (e.g., by pressing Alt+Tab), your exam will be automatically
//                   canceled after 4 seconds.
//                 </li>
//                 <li>
//                   We recommend closing all unnecessary applications and
//                   minimizing distractions before you begin.
//                 </li>
//                 <li>
//                   Thank you for your understanding, and best of luck on your
//                   exam!
//                 </li>
//               </ul>
//             </div>
//             <div className="flex flex-wrap py-4   justify-center">
//               <div className="lg:w-[300px] px-3 w-full">
//                 <button
//                   onClick={handleClose}
//                   className="inline-block rounded text-white bg-blue-500 hover:bg-blue-600 border-blue-500  border-2 px-4 lg:py-1   text-sm max-sm:p-1 leading-normal w-full lg:w-[200px]"
//                 >
//                   {examIn > 0
//                     ? "Okey, I understand"
//                     : isResume
//                     ? "Resume Test"
//                     : "Start Test"}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </Box>
//     </Modal>
//   );
// };

export const GuideLine = ({
  handleClose,
  open,
  examIn,
  isResume,
  setOpen,
}: any) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] flex flex-col">
        {/* Header */}
        <div className="bg-gradient-to-r  from-blue-600 to-blue-700 text-white p-6 rounded-t-2xl relative">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center">
              <Clock className="text-white" size={24} />
            </div>
            <div>
              <h1 className="text-2xl font-bold">Examination Instructions</h1>
              <p className="text-blue-100">
                Please read carefully before starting
              </p>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="p-6 space-y-8 overflow-y-auto flex-1">
          {/* General Instructions */}
          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
              <NotebookPen className="text-orange-500" size={20} />
              General Instructions
            </h2>
            <div className="bg-orange-50 border-l-4 border-orange-500 p-4 rounded-r-lg">
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-start gap-2">
                  <span className="text-orange-500 mt-1">•</span>
                  <span>
                    Do <strong>not minimize or close </strong> the exam window
                    during the examination
                  </span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-orange-500 mt-1">•</span>
                  <span>
                    Do <strong>not open any other tab or page</strong> during
                    the examination
                  </span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-orange-500 mt-1">•</span>
                  <span>
                    Your exam will be <strong> submitted automatically</strong>{" "}
                    at the end of the exam duration
                    {/* The exam will automatically submit when time expires */}
                  </span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-orange-500 mt-1">•</span>
                  <span>
                    Click <strong>"Save & Next"</strong> button to save your
                    answers
                  </span>
                </li>
              </ul>
            </div>
          </section>

          {/* Question Status Legend */}

          {/* Navigation Rules */}
          {/* <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-4">Navigation Guidelines</h2>
            <div className="bg-blue-50 border-l-4 border-blue-500 p-4 rounded-r-lg space-y-3">
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 bg-blue-500 text-white rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                  <span className="text-xs font-bold">1</span>
                </div>
                <p className="text-gray-700">
                  <strong>Initial Navigation:</strong> You must visit questions in sequence (1, 2, 3...) when moving forward
                </p>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 bg-blue-500 text-white rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                  <span className="text-xs font-bold">2</span>
                </div>
                <p className="text-gray-700">
                  <strong>Backward Navigation:</strong> You can jump to any previously visited question using the right panel
                </p>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 bg-blue-500 text-white rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                  <span className="text-xs font-bold">3</span>
                </div>
                <p className="text-gray-700">
                  <strong>Free Navigation:</strong> After visiting all questions, you can jump to any question freely
                </p>
              </div>
            </div>
          </section> */}

          {/* Submission Process */}
          {/* <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-4">Submission Process</h2>
            <div className="bg-green-50 border-l-4 border-green-500 p-4 rounded-r-lg space-y-2">
              <p className="text-gray-700">
                <strong>Submit Button:</strong> Becomes available only after visiting all questions
              </p>
              <p className="text-gray-700">
                <strong>Review Mode:</strong> If you have skipped or marked questions, you'll be offered a review mode to quickly navigate to those questions
              </p>
              <p className="text-gray-700">
                <strong>Final Submission:</strong> Ensure all questions are answered before final submission
              </p>
            </div>
          </section> */}

          {/* Important Notes */}
          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-4 flex items-center gap-x-2">
              <TriangleAlert className="text-orange-500" size={20} />
              Important Notes
            </h2>
            <div className="bg-red-50 border-l-4 border-red-500 p-4 rounded-r-lg">
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-start gap-2">
                  <span className="text-orange-500 mt-1">•</span>

                  <span>Once submitted, you cannot modify your answers</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-orange-500 mt-1">•</span>

                  <span>
                    Keep track of time using the timer in the top-right corner
                  </span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-orange-500 mt-1">•</span>

                  <span>
                    Use the question panel on the right to track your progress
                  </span>
                </li>
              </ul>
            </div>
          </section>
        </div>

        {/* Footer */}
        <div className="bg-gray-50 px-6 py-4 rounded-b-2xl flex justify-end gap-3 border-t flex-shrink-0">
          <button
            onClick={() => setOpen(false)}
            className="inline-block rounded text-white bg-gray-500 hover:bg-gray-600 border-gray-500  border-2  lg:py-1   text-lg max-sm:p-1 leading-normal w-full lg:w-[120px]"
          >
            Close
          </button>
          <button
            onClick={handleClose}
            className="inline-block rounded text-white text-lg bg-blue-500 hover:bg-blue-600 border-blue-500  border-2 px-4 lg:py-1   max-sm:p-1 leading-normal w-full lg:w-[200px]"
          >
            {examIn > 0
              ? "Okey, I understand"
              : isResume
              ? "Resume Exam"
              : "Start Exam"}
          </button>
        </div>
      </div>
    </div>
  );
};